import { ZoomPropertyViewModel } from './zoom-property-view-model';
import type { MessageContainerInterface, ModifiedSubscriberInterface, NumericMetaDataInterface } from '@nts/std/interfaces';
import { BigNumber } from '@nts/std/types';
import { NumericHelper } from '@nts/std/utility';

export class NumericZoomPropertyViewModel extends ZoomPropertyViewModel<BigNumber | number> {

  isDecimal = false;
  metaDataMinValue: BigNumber | number | null;
  metaDataMaxValue: BigNumber | number | null;
  metaDataPrecision: number;
  metaDataScale: number;
  mask: string;
  format: string;
  decimalLimit: number | null;
  integerLimit: number | null;
  useThousandSeparator = false;

  constructor(
    propertyMetaData: NumericMetaDataInterface,
    modifiedSubscriber: ModifiedSubscriberInterface
  ) {
    super(propertyMetaData, modifiedSubscriber);

    this.isDecimal = propertyMetaData.isDecimal;
    this.metaDataMinValue = propertyMetaData.minValue ?? null;
    this.metaDataMaxValue = propertyMetaData.maxValue ?? null;

    if (propertyMetaData.maxIntegerPrecision == null) {
      propertyMetaData.maxIntegerPrecision = 10;
    }

    this.decimalLimit = propertyMetaData.maxDecimalPrecision ?? null;
    this.integerLimit = propertyMetaData.maxIntegerPrecision ?? null;

    if (this.decimalLimit && this.decimalLimit > 0) {
      this.useThousandSeparator = true;
    }

    this.format = NumericHelper.getNumericFormat(this.integerLimit, this.decimalLimit, this.useThousandSeparator, propertyMetaData.name);
  }

  override removeError(item: MessageContainerInterface) {
    throw new Error("Method not implemented.");
  }

  setValue(propertyValue: Object) {
    if (propertyValue === null) {
      this.typedValue = null;
    } else {
      let v = parseFloat(propertyValue.toString());
      // Se è maggiore dell'int, imposto l'int max value.
      // Non ho però modo di capire quando è short.
      if (v > 2147483647) {
        v = 2147483647;
      }
      this.typedValue = v;
    }
  }
}
